import dropdown from "./dropdown"
import { debounce, jsonFetch } from "./utilities"

class Suggester {
  constructor(el, options={}) {
    this._input = el;
    this._suggestions = [];
    this._cache = {};
    this._blanks = [];
    this._form = this._input.closest("form")
    this._options = Object.assign({
      fill_field: true,
      empty_field: false,
      submit_form: false,
      preload: false,
      width: "auto",
      threshold: 2,
      limit: 10,
      onSuggest: null,
      onSelect: null,
    }, options);
    if (options.type) {
      this._options.url ||= `/suggestions/${options.type}`
    } else {
      this._options.url ||= "/suggestions"
    }
    this._input.addEventListener("input", debounce(this.suggest.bind(this)));
    if (this._options.preload) {
      this.suggest(null, true)
    }
  }

  suggest(e, force) {
    const q = this._input.value;
    if (force || q.length > this._options.threshold) {
      if (this.knownToBeBlank(q)) {
        this.clearSuggestionList();
      } else if (this.alreadyFetched(q)) {
        this.buildSuggestionList(q);
      } else {
        this.fetchSuggestions(q);
      }
    } else {
      this.clearSuggestionList();
    }
  }

  fetchSuggestions(q) {
    this._input.classList.add('waiting');
    let url = this._options.url
    let qs = new URLSearchParams()
    if (q) qs.set('term', q);
    if (this._options.preload) qs.set('empty', 'all');
    jsonFetch(`${url}?${qs}`).then(json => {
      this.receiveSuggestions(q, json);
    });
  }

  receiveSuggestions(q, data) {
    let suggestion_data;
    this._input.classList.remove('waiting');
    if (data) {
      if (data.length == 0) {
        this.recordBlank(q);
      } else {
        this._cache[q] = data;
        this.buildSuggestionList(q);
      }
    }
  }

  buildSuggestionList(q) {
    this._suggestions = this._cache[q] || [];
    this._dropdown ||= dropdown(this._input, { onSelect: this.acceptSuggestion.bind(this) });
    this._dropdown.show(this.prepareSuggestions(this._suggestions));
  }

  prepareSuggestions(suggestions) {
    console.log('base prepareSuggestions', suggestions);
    suggestions.forEach((sugg) => {
      if (!sugg.prompt) sugg.prompt = sugg.name;
    })
    return suggestions;
  }

  clearSuggestionList() {
    if (this._dropdown) this._dropdown.reset();
  }

  alreadyFetched(query) {
    return !!this._cache[query];
  }

  recordBlank(query) {
    this._blanks.push(query);
    this._blanks_re = new RegExp("^(" + this._blanks.join("|") + ")");
  }

  knownToBeBlank(query) {
    if (this._blanks_re) {
      return this._blanks_re.test(query);
    }
    return false;
  }

  acceptSuggestion(value, id) {
    if (typeof id !== 'number') {
      id = parseInt(id, 10);
    }
    const suggestion = this._suggestions.find((sugg) => sugg.id === id);
    if (this._options.fill_field) {
      this._input.value = value;
    } else if (this._options.empty_field) {
      this._input.value = "";
    }
    if (this._options.onSelect) {
      this._options.onSelect.call(this, value, id, suggestion);
    }
  }
}

function suggester(el, options={}) {
  return new Suggester(el, options);
}

class OrganisationSuggester extends Suggester {
  prepareSuggestions(suggestions) {
    console.log('📎 OS prepareSuggestions', suggestions);
    suggestions.forEach((sugg) => {
      if (!sugg.prompt) {
        const years = (sugg.years || []).join(', ');
        sugg.prompt = `${sugg.name} (${years})`;
      }
    })
    return suggestions;
  }
}

function organisationSuggester(el, options={}) {
  return new OrganisationSuggester(el, Object.assign({
    type: 'organisation',
    threshold: 2,
    submit_form: false,
  }, options));
}

function venueSuggester(el) {
  return new Suggester(el, {
    type: 'venue',
    threshold: 2,
    submit_form: false,
  });
}

export {
  suggester,
  venueSuggester,
  organisationSuggester
}; 